import React, { useEffect, useCallback, useState } from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { LogTableWrapper, RunInstanceIdTitle } from './styled';
import tableColumns from './columns';
import { hasAttributeValue } from '../../../../../util';
import { getSelectedResources } from '../../../../../util/resourceManager';
import { toLower } from '../../../../../util/lodashlike';
import useAlertLevelConfigs from '../../../../common/hooks/useAlertLevelConfig';

const DEFAULT_CURRENT_PAGE = 1;
const PAGE_SIZE = 10;
const { trmResources } = getSelectedResources();

const ActivityLogTab = ({
  apiActions = {},
  runInstanceHistoryList,
  scenarioID,
  isLoading,
  trmActions,
  authentication,
  alertLevels = []
}) => {
  const {
    fetchRunInstanceHistory,
    fetchTypologiesActions,
    fetchAMLSAlertLevel
  } = apiActions;
  const [pagination, setPagination] = useState({
    page: DEFAULT_CURRENT_PAGE,
    pageSize: PAGE_SIZE
  });

  const preventionResourceAccess = hasAttributeValue(
    authentication,
    trmResources.APP_3_RESOURCE_UI_RUN_INSTANCE,
    '24'
  );

  const { getLevelColor } = useAlertLevelConfigs(alertLevels);

  // FIN-12133: colour-code the Action by its configured severity's level colour
  // (action_severity -> alert_level_details), consistent with the Score Explanation.
  const getActionColor = useCallback(
    (action) =>
      getLevelColor(
        trmActions?.data?.find(
          ({ displayName }) => toLower(displayName) === toLower(action)
        )?.actionSeverity
      ),
    [trmActions, getLevelColor]
  );

  useEffect(() => {
    fetchRunInstanceHistory({
      scenarioID,
      ...pagination
    });

    if (preventionResourceAccess) {
      fetchTypologiesActions();
      if (typeof fetchAMLSAlertLevel === 'function' && !alertLevels?.length) {
        fetchAMLSAlertLevel();
      }
    }
  }, []);

  const onPaginationChange = useCallback((page, pageSize) => {
    setPagination({ page, pageSize });
    fetchRunInstanceHistory({
      scenarioID,
      page,
      pageSize
    });
  });

  const { instances = [], scenario } = runInstanceHistoryList || {};

  return (
    <>
      <RunInstanceIdTitle>{`Run Instance Id: ${
        scenario?.id || ''
      }`}</RunInstanceIdTitle>
      <LogTableWrapper>
        <Table
          loading={isLoading}
          dataSource={instances?.payload}
          columns={tableColumns(
            trmActions,
            preventionResourceAccess,
            getActionColor
          )}
          pagination={{
            total: instances?.total,
            onChange: onPaginationChange,
            showTotal: (total) => `${total} Records`,
            ...pagination
          }}
        />
      </LogTableWrapper>
    </>
  );
};

ActivityLogTab.propTypes = {
  runInstanceHistoryList: PropTypes.object,
  apiActions: PropTypes.object,
  scenarioID: PropTypes.string,
  isLoading: PropTypes.bool
};

export default ActivityLogTab;
